var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitePlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12255 12.1096L19.6225 1.60955M9.25015 12.4376L11.8782 19.1956C12.1097 19.791 12.2255 20.0886 12.3923 20.1755C12.5369 20.2509 12.7092 20.251 12.8538 20.1758C13.0207 20.0891 13.1369 19.7916 13.3691 19.1965L19.9594 2.30875C20.1691 1.77157 20.2739 1.50298 20.2165 1.33135C20.1667 1.1823 20.0498 1.06533 19.9007 1.01554C19.7291 0.958206 19.4605 1.06302 18.9233 1.27265L2.03563 7.86299C1.44055 8.09522 1.14302 8.21133 1.05631 8.37823C0.981136 8.52292 0.981236 8.6952 1.05658 8.8398C1.14348 9.0066 1.44116 9.1223 2.0365 9.3539L8.79455 11.982C8.91535 12.029 8.97575 12.0525 9.02665 12.0888C9.07175 12.1209 9.11115 12.1604 9.14335 12.2055C9.17965 12.2563 9.20315 12.3168 9.25015 12.4376Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlane);
export default __webpack_public_path__ + "static/media/white_plane.cbeaaefce183e1ffa3275f44e4b326b5.svg";
export { ForwardRef as ReactComponent };